export default __webpack_public_path__ + "static/media/cloze-text-blue.97dfe2c1.svg";